import { z } from "zod";
const noResultToolOutputSchema = z.object({
  no_result: z.literal(true).describe(
    "Marks an expected, user-actionable condition (not a system failure): the tool ran fine but could not produce its normal result. See `message`."
  ),
  message: z.string().describe(
    "Why the tool could not produce its normal result. Relay it to the user and adjust your next step accordingly (e.g. broaden the date range, configure the missing data, or pick a different target)."
  )
});
function withNoResult(schema) {
  return z.union([schema, noResultToolOutputSchema]);
}
function checkIsNoResultToolOutput(value) {
  return noResultToolOutputSchema.safeParse(value).success;
}
export {
  checkIsNoResultToolOutput,
  noResultToolOutputSchema,
  withNoResult
};
//# sourceMappingURL=noResultToolOutput.js.map
